import { MenuItem, Typography, Divider, ListItem, ListItemText, Menu } from '@mui/material';
import { MouseEvent } from 'react';
import { SubMenuTabellaDiServizioItemsEnum } from './constants';

interface SubMenuTabelleDiServizioProps {
  onClick: (event: MouseEvent<HTMLElement>) => void;
  onClose: (event: MouseEvent) => void;
  submenuAnchor: Element | null;
  onClickGestioneDomini: () => void;
  onClickGestioneComuni: () => void;
  onClickGestioneLuoghiNascita: () => void;
  onClickGestioneLuoghiDecesso: () => void;
  onClickGestioneAutoritaDecesso: () => void;
  onClickGestioneCultiReligiosi: () => void;
  onClickGestioneMinistri: () => void;
  isSubmenuVisible: boolean;
  value: string;
  withMunicipality?: boolean;
  withDomain?: boolean;
  withBirthpalaces?: boolean;
}

const SubMenuTabelleDiServizio = ({
  value,
  submenuAnchor,
  isSubmenuVisible,
  onClose,
  onClick,
  onClickGestioneDomini,
  onClickGestioneComuni,
  onClickGestioneLuoghiNascita,
  onClickGestioneLuoghiDecesso,
  onClickGestioneAutoritaDecesso,
  onClickGestioneCultiReligiosi,
  onClickGestioneMinistri,
  withMunicipality,
  withDomain,
  withBirthpalaces,
}: SubMenuTabelleDiServizioProps): React.ReactElement => {
  return (
    <>
      <ListItem onClick={onClick}>
        <ListItemText primary={value} />
      </ListItem>
      <Menu
        id={`${value}-menu`}
        anchorEl={submenuAnchor}
        open={isSubmenuVisible}
        onClose={onClose}
        PaperProps={{
          style: {
            width: '40ch',
          },
        }}
      >
        {withDomain ? (
          <MenuItem
            key="gestione-avanzata-dominio"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              event.nativeEvent.stopImmediatePropagation();
              onClose(event);
              onClickGestioneDomini();
            }}
          >
            <Typography variant="inherit">
              {SubMenuTabellaDiServizioItemsEnum.GESTIONE_GENERICA_DOMINI}
            </Typography>
          </MenuItem>
        ) : undefined}
        {withMunicipality && withDomain ? (
          <Divider key="gestione-comune-nascita-morte-divider" />
        ) : undefined}
        {withMunicipality ? (
          <MenuItem
            key="gestione-comune-nascita-morte"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              event.nativeEvent.stopImmediatePropagation();

              onClose(event);
              onClickGestioneComuni();
            }}
          >
            <Typography variant="inherit">
              {SubMenuTabellaDiServizioItemsEnum.GESTIONE_COMUNI_NASCITA_MORTE}
            </Typography>
          </MenuItem>
        ) : undefined}
        {withBirthpalaces && (withMunicipality || withDomain) ? (
          <Divider key="gestione-luoghi-codificati-nascita-divider" />
        ) : undefined}
        {withBirthpalaces ? (
          <MenuItem
            key="gestione-luoghi-codificati-nascita"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              event.nativeEvent.stopImmediatePropagation();

              onClose(event);
              onClickGestioneLuoghiNascita();
            }}
          >
            <Typography variant="inherit">
              {SubMenuTabellaDiServizioItemsEnum.GESTIONE_LUOGHI_CODIFICATI_NASCITA}
            </Typography>
          </MenuItem>
        ) : undefined}
        {/* TODO autorizzazioni */}
        <Divider key="gestione-luoghi-codificati-decesso-divider" />
        <MenuItem
          key="gestione-luoghi-codificati-decesso"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();

            onClose(event);
            onClickGestioneLuoghiDecesso();
          }}
        >
          <Typography variant="inherit">
            {SubMenuTabellaDiServizioItemsEnum.GESTIONE_LUOGHI_CODIFICATI_DECESSO}
          </Typography>
        </MenuItem>
        {/* TODO autorizzazioni */}
        <Divider key="gestione-luoghi-codificati-decesso-divider" />
        <MenuItem
          key="gestione-luoghi-codificati-decesso"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();

            onClose(event);
            onClickGestioneAutoritaDecesso();
          }}
        >
          <Typography variant="inherit">
            {SubMenuTabellaDiServizioItemsEnum.GESTIONE_AUTORITA_DECESSO}
          </Typography>
        </MenuItem>
        {/* TODO autorizzazioni */}
        <Divider key="gestione-culti-religiosi-divider" />
        <MenuItem
          key="gestione-culti-religiosi"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();

            onClose(event);
            onClickGestioneCultiReligiosi();
          }}
        >
          <Typography variant="inherit">
            {SubMenuTabellaDiServizioItemsEnum.GESTIONE_CULTI_RELIGIOSI}
          </Typography>
        </MenuItem>
        {/* TODO autorizzazioni */}
        <Divider key="gestione-ministri-divider" />
        <MenuItem
          key="gestione-ministri"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();

            onClose(event);
            onClickGestioneMinistri();
          }}
        >
          <Typography variant="inherit">
            {SubMenuTabellaDiServizioItemsEnum.GESTIONE_MINISTRI}
          </Typography>
        </MenuItem>
      </Menu>
    </>
  );
};

SubMenuTabelleDiServizio.displayName = 'Sub Menu Tabelle Di Servizio';
export default SubMenuTabelleDiServizio;
